import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useFeatures } from '../settings/hooks/useSettingsState';
import { Flex, SubPage, Typo } from '../../ui';
import ClassroomList from './components/ClassroomList';
import ClassroomView from './components/ClassroomView';

const FeatureDisabled = styled(Flex)`
  padding: 3rem;
  text-align: center;
`;

const Classroom = () => {
  const { t } = useTranslation();
  const features = useFeatures();
  const { groupId } = useParams();

  if (!features?.classroom) {
    return (
      <SubPage>
        <FeatureDisabled direction='column' gap='10' align='center' justify='center'>
          <Typo.ContentSmallHeader>{t('classroom.featureDisabled', 'Classroom Mode is not enabled')}</Typo.ContentSmallHeader>
          <Typo.MediumText>{t('classroom.enableInSettings', 'Enable it in Settings > Features')}</Typo.MediumText>
        </FeatureDisabled>
      </SubPage>
    );
  }

  if (groupId) {
    return <ClassroomView groupId={groupId} />;
  }

  return <ClassroomList />;
};

export default Classroom;
